import axios from 'axios'
import alertHelper from '@/helpers/alert'
import config from '@/config'

export default {
  namespaced: true,
  state: {
    feeTypes: [],
    gstStatus: '2',
    gstOptions: [
      { text: 'No GST', value: 0 },
      { text: 'Exclude GST', value: 2 },
    ],
    week_before:1
  },
  getters: {
    getFeeTypes: (state) => {
      return state.feeTypes
    },
    getFeeTypeById: (state) => (id) => {
      const type = state.feeTypes.filter(type => type.id === id)
      return type.length > 0 ? type[0] : {}
    },
    getGstStatus: (state) => {
      return state.gstStatus
    },
    getGstOptions: (state) => {
      return state.gstOptions
    },
    getWeekBefore:(state) =>{
      return state.week_before
    }
  },
  mutations: {
    setFeeTypes: (state, data) => {
      if (typeof data.length === 'undefined') {
        state.feeTypes.push(data)
      } else if (data.length > 0) {
        state.feeTypes = data
      }
    },
    setGstStatus: (state, data) => {
      const selected = state.gstOptions.filter((s) => +s.value === +data)

      if (selected.length === 0) {
        state.gstStatus = []
      } else {
        state.gstStatus = selected[0]
      }
    },
    setWeekBefore: (state, data) => {
      state.week_before = data
    },
    updateFeeType: (state, data) => {
      state.feeTypes.forEach((s) => {
        if (data.id === s.id) {
          s.fee_name = data.fee_name
          s.fee_comment = data.fee_comment
        }
      })
    },
    deleteFeeType: (state, id) => {
      state.feeTypes.forEach((s, index) => {
        if (s.id === id) {
          state.feeTypes.splice(index, 1)
        }
      })
    },
  },
  actions: {
    init(context) {
      context.dispatch('fetchFeeTypes')
      context.dispatch('getAccount')
    },
    async fetchFeeTypes(context) {
      const url = config.apiBaseUrl + 'fee_type'

      try {
        const response = await axios.get(url)

        if (response.data.errmsg === '') {
          context.commit('setFeeTypes', response.data.data)
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    async addFeeType(context, data) {
      const url = config.apiBaseUrl + 'fee_type'

      try {
        const response = await axios.post(url, data)

        if (response.data.errmsg === '') {
          data.id = response.data.data.id
          context.commit('setFeeTypes', data)
          alertHelper.success('Successfully added the fee type')
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    async getAccount(context) {
      const url = config.apiBaseUrl + 'account/get'

      try {
        const response = await axios.get(url)

        if (response.data.errmsg === '') {
          context.commit('User/setUser', response.data.data,  { root: true })
          context.commit('setGstStatus', response.data.data.mf_gst_status)
          context.commit('setWeekBefore',response.data.data.week_before)
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    async updateAccountGstStatus(context, data) {
      const url = config.apiBaseUrl + 'account/update'
      const userString = window.sessionStorage.getItem('user')
      const user = JSON.parse(userString)
      try {
        const response = await axios.post(url, {
          id: user.accountId,
          mf_gst_status: data,
        })

        if (response.data.errmsg === '') {
          context.commit('setGstStatus', data)
          alertHelper.success('Successfully updated GST option')
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    async updateFeeType(context, data) {
      const url = config.apiBaseUrl + 'fee_type/' + data.id

      try {
        const response = await axios.put(url, data)

        if (response.data.errmsg === '') {
          context.commit('updateFeeType', data)
          alertHelper.success('Successfully updated the fee type')
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    async deleteFeeType(context, id) {
      const url = config.apiBaseUrl + 'fee_type/' + id

      try {
        const response = await axios.delete(url)

        if (response.data.errmsg === '') {
          context.commit('deleteFeeType', id)
          alertHelper.success('Successfully deleted the fee type')
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
  },
}
